
import { Outlet } from "react-router-dom";

export const RefundInitiationOutlet = () => {
  return <Outlet />;
};
